import React, { useEffect, useState } from "react";
import { AccountBannerPreferenceVisibility } from "types/src/types/AccountBannerPreference";
import { useAccount, useSeller } from "@/hooks/useAccount";

const BANNER_DISMISS_KEY = "accountBannerDismissed";

export const AccountBanner = () => {
    const seller = useSeller();
    const { data } = useAccount();
    const { delegators = [] } = data ?? {};

    const [dismissed, setDismissed] = useState(false);

    const handleDismiss = () => {
        sessionStorage.setItem(BANNER_DISMISS_KEY, "true");
        setDismissed(true);
    };

    useEffect(() => {
        const isDismissed = sessionStorage.getItem(BANNER_DISMISS_KEY) === "true";
        setDismissed(isDismissed);

        const handleBeforeUnload = () => {
            sessionStorage.removeItem(BANNER_DISMISS_KEY);
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, []);

    if (!seller?.preferences?.accountBanner?.visibility || dismissed) {
        return null;
    }

    const { visibility } = seller.preferences.accountBanner;

    if (
        visibility === AccountBannerPreferenceVisibility.SHOW ||
        (visibility === AccountBannerPreferenceVisibility.SHOW_IF_MULTIPLE_DELEGATORS && delegators.length > 1)
    ) {
        return (
            <div className="ui-account-banner flex h-10 w-full items-center justify-center bg-gradient-to-r from-[#583DFF] via-[#AB5ACB] to-[#FFC03D] text-lg font-bold text-white">
                <div className="flex w-full items-center justify-center">{seller.name}</div>
                <span
                    className="hover:text-gray-200 w-8 cursor-pointer pr-4 text-center text-black"
                    aria-label="Dismiss banner"
                    onClick={handleDismiss}
                >
                    ×
                </span>
            </div>
        );
    }

    return null;
};
